import { CalculatorListener } from '../modules/calculator';
import { handleVariantSelection } from '../modules/variant-picker';
import { sampleFormBackInStockListener } from '../modules/back-in-stock-form';
import debounce from "../utils/debounce";
import {
  Tab,
  Tooltip,
  initTE,
} from "tw-elements";
import {
  setupActionButtonListeners,
  setupAddToCartButtonListeners,
  setupItemEditingListeners
} from '../modules/cart';

initTE({ Tab, Tooltip });
// Set up event listeners in the document:
setupActionButtonListeners();
setupItemEditingListeners();
setupAddToCartButtonListeners();
handleVariantSelection();
sampleFormBackInStockListener();

const sqftInputListenerId = 'sqft-input-js';
new CalculatorListener(sqftInputListenerId, 'overage-select', 'product');

document.addEventListener('DOMContentLoaded', () => {
  const calculatorAccordion = document.getElementById('calculator') as HTMLElement;

  calculatorAccordion?.addEventListener('show.te.collapse', () => {
    const inputUnitNeededElement = document.getElementById(sqftInputListenerId) as HTMLInputElement;

    if (inputUnitNeededElement) {
      inputUnitNeededElement.dispatchEvent(new Event('input', { bubbles: true }));
      if (inputUnitNeededElement.value !== '1') {
        inputUnitNeededElement.value = '';
        const debouncedFocus = debounce(() => inputUnitNeededElement.focus(), 500);
        debouncedFocus();
      }
    } else {
      console.error(`Element with ID '${sqftInputListenerId}' not found.`);
    }
  });

  const carousel = document.getElementById('carousel') as HTMLElement;
  if (!carousel) return;

  let isMouseDown = false;
  let startX = 0;
  let startY = 0;

  carousel.addEventListener('mousedown', (e: MouseEvent) => {
    e.preventDefault();
    isMouseDown = true;
    startX = e.clientX;
    startY = e.clientY;
  });

  document.addEventListener('mouseup', (e: MouseEvent) => {
    if (!isMouseDown) return;
    isMouseDown = false;
    const endX = e.clientX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) > Math.abs(e.clientY - startY)) {
      clickSlideButton(deltaX > 0 ? 'next' : 'prev');
    }
  });

  function clickSlideButton(direction: 'next' | 'prev') {
    const selector = `[data-te-slide="${direction}"]`;
    const button = carousel.querySelector(selector) as HTMLButtonElement;
    if (button) button.click();
  }
});
